import { StandardEvents } from '@shopify/events';

// Keep the shared storefront header in sync with Shopify's native cart controls.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (typeof count !== 'number') return;
    document.querySelectorAll('.gg-navbar [data-cart-count]').forEach((badge) => {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = count === 0;
      badge.closest('a')?.setAttribute('aria-description', `${count} items in cart`);
    });
  }).catch(() => { /* Failed updates retain the last confirmed quantity. */ });
});
